import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { productBrief } from "../data/productBrief";
export function WorkshopsSection() {
  return <section className="section wash" id="workshops" aria-labelledby="workshops-heading" data-id="element-210" data-mp="16pmi5sj7mcrv">
      <div className="shell" data-id="element-211" data-mp="1boz4mc665htx">
        <div className="section-intro" data-id="element-212" data-mp="1bo66fzla00ne">
          <p className="eyebrow" data-id="element-213" data-mp="1bn4qphtbepzc">VOLUME 1 · THE 5 WORKSHOPS</p>
          <h2 id="workshops-heading" data-id="element-214" data-mp="f09l6hew8h5u">
            Five foundational skills, <span data-id="element-215" data-mp="j0a9ctrso6q3">one planned session at a time</span>
          </h2>
          <p data-id="element-216" data-mp="iyh51l4nlyl9">
            Requests, listening, updates, handoffs and everyday misunderstandings. Run them in sequence or pick the skill your
            team needs next.
          </p>
        </div>
        <ol className="workshop-list" data-id="element-217" data-mp="ssg3a91lwy7x">
          {productBrief.workshops.map(workshop => <li key={workshop.number} data-id="element-218" data-mp="3reajzvjc7207">
              <span className="workshop-number" aria-hidden="true" data-id="element-219" data-mp="9k6v664ylxr">
                {String(workshop.number).padStart(2, "0")}
              </span>
              <div data-id="element-220" data-mp="1st8b0wifcp05">
                <h3 data-id="element-221" data-mp="1svuikw5bf4id">{workshop.title}</h3>
                <p data-id="element-222" data-mp="1os6a8b8v04w2">{workshop.outcome}</p>
                <span className="workshop-vol" data-id="element-223" data-mp="1ot7un6brm3qg">VOLUME {workshop.volume}</span>
              </div>
            </li>)}
        </ol>
        <div className="section-action" data-id="element-224" data-mp="1f2v14olz3086">
          <CtaButton href="#offer-details" data-id="element-225" data-mp="1f1to4elec3nt">
            See the Volume 1 offer — $27 <ArrowRightIcon size={18} aria-hidden="true" data-id="element-226" data-mp="1a3s8k3n6imh3" />
          </CtaButton>
        </div>
      </div>
    </section>;
}